<template>
  <div>
    <v-card class="ma-6 pa-6" outlined>
      <DiligenceFilter @onFilterChanged="refresh" />
    </v-card>
    <v-card class="ma-6" outlined>
      <DiligenceDataTable ref="diligence-data-table" />
    </v-card>
  </div>
</template>

<script>
import DiligenceFilter from './components/DiligenceFilter'
import DiligenceDataTable from './components/DiligenceDataTable'

export default {
  components: {
    DiligenceFilter,
    DiligenceDataTable
  },
  methods: {
    refresh(query) {
      this.$refs['diligence-data-table'].searchStudentDiligences(query)
    }
  }
}
</script>
